import type { Dictionnaire } from '../type';

export const carte: Dictionnaire['carte'] = {
  ecran: {
    voirTout: 'Ver todo',
    dansLaZone: 'En esta zona',
    impossible: 'No se puede ahora mismo.',
    recherchePosition: 'Buscando tu posición…',
    activerLocalisation: 'Activa la ubicación para verte en el mapa',
    unSansAdresse: 'Un evento sin dirección precisa no aparece.',
    revenir: 'Volver a mi posición',
    personneInscrit: 'Todavía no hay nadie apuntado',
    inscrit: 'Estás apuntado',
    demandeEnvoyee: 'Solicitud enviada',
    listeAttente: 'Unirme a la lista de espera',
    rejoindre: 'Unirme a este evento',
    plusTard: 'Quizá más tarde',
    aucun: 'Ningún evento',
    un: '1 evento',
    videCarte: 'Todavía no hay ningún evento en el mapa. Los próximos aparecerán solos.',
    videZone: 'Nada en esta parte del mapa. Aléjate o muévelo para ver otros.',
    sansAdresse: (n: number) => `${n} eventos sin dirección precisa no aparecen.`,
    participants: (n: number) => (n === 1 ? '1 participante' : `${n} participantes`),
    memeEndroit: (n: number) => `${n} eventos en el mismo lugar`,
    plusieurs: (n: number) => `${n} eventos`,
  },
  apple: {
    pasOuverte: 'No se ha podido abrir el mapa de Apple.',
    pasChargee: 'No se ha podido cargar el mapa de Apple.',
  },
  libre: {
    pasAffichee: 'El mapa no se puede mostrar en este dispositivo.',
    pasChargee: 'No se ha podido cargar el mapa. Revisa tu conexión.',
  },
  placer: {
    titre: 'Situar en el campus',
    deplacer: 'Mueve el marcador con el dedo para ajustarlo.',
    toucher: 'Toca el plano donde será el evento.',
    placerIci: 'Situar aquí',
  },
  pastilles: {
    maPosition: 'Mi posición',
    sortie: (titre: string, categorie: string, spontanee: boolean) =>
      `${titre}, ${categorie.toLowerCase()}${spontanee ? ', espontánea' : ''}`,
    groupe: (n: number) => `${n} salidas en este lugar`,
  },
  maquette: {
    pasAffichee: 'La maqueta no se puede mostrar en este dispositivo.',
  },
  placerMaquette: {
    pasAffichee: 'La maqueta no se puede mostrar en este dispositivo.',
    deplacer: 'Toca en otro sitio para moverlo.',
    toucher: 'Toca la maqueta donde será el evento.',
  },
  apercu: {
    credits: '© OpenStreetMap · OpenFreeMap',
    carteDuLieu: (lieu: string) => `Mapa del lugar: ${lieu}`,
  },
};
